import React from 'react';
import LavLiterpris from '../../../../../containers/commerce/LavLiterpris';
import { Row, Col } from '../../../../grid';

const RenderLavLiterpris = ({
  lavLiterpris,
}) => {
  if (lavLiterpris) {
    return (
      <Row>
        <Col xs={12}>
          <LavLiterpris lavLiterpris={lavLiterpris} />
        </Col>
      </Row>
    );
  }
  return (null);
};

// Export
export default RenderLavLiterpris;
